/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Center__Bidding_N_Battles__NameInputs */

const en_help_center__bidding_n_battles__name = /** @type {(inputs: Help_Center__Bidding_N_Battles__NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bidding & Battles`)
};

/**
* | output |
* | --- |
* | "Bidding & Battles" |
*
* @param {Help_Center__Bidding_N_Battles__NameInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const help_center__bidding_n_battles__name = /** @type {((inputs?: Help_Center__Bidding_N_Battles__NameInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Center__Bidding_N_Battles__NameInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_help_center__bidding_n_battles__name(inputs)
});